module.exports = __webpack_public_path__ + "static/media/2.80af4154.jpg";